export enum KPI_CODE {
  SALES_AMOUNT = 'salesAmount',
  DIFF_RATE = 'diffRate'
}
